export default __webpack_public_path__ + "f2389a7c3f810c2979378587f252e6fe.jpg";